import React, { useState, useEffect } from "react";
import moment from "moment";
import DinamicModal from '../../components/dinamicModal/dinamicModal';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';


const request = new Request();


function PropietarioEditarModal({ propietario, subLabel, escritura, closeModal, reload }) {
  // Estados
  const [idPersona, setIdPersona] = useState(propietario.id_persona || "");
  const [INombre, setINombre] = useState(propietario.nombre || "");
  const [IDireccion, setIDireccion] = useState(propietario.direccion || "");
  const [IMunicipio, setIMunicipio] = useState(propietario.municipio || "");
  const [IEstado, setIEstado] = useState(propietario.estado || "");
  const [ICp, setICp] = useState(propietario.cp || "");
  const [ITelefono, setITelefono] = useState(propietario.telefono || "");
  const [IPais, setIPais] = useState(propietario.pais || "");
  const [IGenero, setIGenero] = useState(propietario.genero || "");
  const [IId, setIId] = useState(propietario.tipo_identificacion || 0);
  const [INumId, setINumId] = useState(propietario.num_identificacion || "");
  const [IVigencia, setIVigencia] = useState(propietario.vigencia_identificacion || "");
  const [IFechaIngreso, setIFechaIngreso] = useState(
    propietario.fecha_entrada ? moment(propietario.fecha_entrada).format("YYYY-MM-DD") : ""
  );
  const [code, setCode] = useState(propietario.code || "");
  const [Iviv, setIviv] = useState(propietario.numero_registro || "");
  const [IIdViv, setIIdViv] = useState(propietario.id_vivienda || "");
  const [email, setEmail] = useState(propietario.email || "");
  const [citye, setCitye] = useState(propietario.ciudad || "");
  const [comentarios, setComentarios] = useState(propietario.comentarios || "");
  const [esResidente, setEsResidente] = useState(propietario.es_residente || false);

  const [loadingSave, setLoadingSave] = useState(false);
  const [telefonoError, setTelefonoError] = useState(undefined);

 
	const [pFechaCompra, setPFechaCompra] = useState(propietario.fecha_compra || "");
	const [pFechaVenta, setPFechaVenta] = useState(propietario.fecha_venta || "");

  
  useEffect(() => {
    setIdPersona(propietario.id_persona || "");
    setINombre(propietario.nombre || "");
    setIDireccion(propietario.direccion || "");
    setIMunicipio(propietario.municipio || "");
    setIEstado(propietario.estado || "");
    setICp(propietario.cp || "");
    setITelefono(propietario.telefono || "");
    setIPais(propietario.pais || "");
    setIGenero(propietario.genero || "");
    setIId(propietario.tipo_identificacion || 0);
    setINumId(propietario.num_identificacion || "");
    setIVigencia(propietario.vigencia_identificacion || "");
    setIFechaIngreso(
      propietario.fecha_entrada ? moment(propietario.fecha_entrada).format("YYYY-MM-DD") : ""
    );
    setCode(propietario.code || "");
    setIviv(propietario.numero_registro || "");
    setIIdViv(propietario.id_vivienda || "");
    setEmail(propietario.email || "");
    setCitye(propietario.ciudad || "");
    setComentarios(propietario.comentarios || "");
    setEsResidente(propietario.es_residente || false);
	setPFechaCompra(propietario.fecha_compra || "");
  	setPFechaVenta(propietario.fecha_venta || "");
  }, [propietario]);


  const handleClose = () => {
    closeModal();
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSave(true);

    if (!isValidPhoneNumber(ITelefono)) {
      setTelefonoError("Número inválido");
      setLoadingSave(false);
      return;
    } else {
      setTelefonoError(undefined);
    }

    const resident = esResidente ? 1 : 0;

    const data = {
      idVivienda: IIdViv,
      Nombre: INombre,
      Direccion: IDireccion,
      Municipio: IMunicipio,
      Estado: IEstado,
      cp: ICp,
      Telefono: ITelefono,
      Pais: IPais,
      Genero: IGenero,
      TipoId: IId,
      NumId: INumId,
      Vigencia: IVigencia,
      FechaCompra: propietario.fecha_compra || "",
      FechaVenta: propietario.fecha_venta || "",
      Code: code,
      IdPersona: idPersona,
      email: email,
      idFraccionamiento: localStorage.getItem("frac") || 0,
      city: citye,
      comentarios: comentarios,
      id_usuario_upd: localStorage.getItem("user_id"),
      residente: resident,
    };

    const response = await request.post("/propietarios/update", data);

    if (response.updated && !response.empty) {
      reload();
      cogoToast.success("Datos del propietario actualizados.", {
        position: "bottom-right",
      });
    } else {
      cogoToast.error("No se pudieron actualizar datos del propietario.", {
        position: "bottom-right",
      });
    }

    setLoadingSave(false);
  };


return (
  <DinamicModal
    idModal="editPropietario"
    sizeModalContainer="big"
    title="Editar propietario"
    success={handleSubmit}
    showBtnSuccess={escritura}
    btnTextSuccess="GUARDAR"
    showBtnCancel={true}
    btnTextCancel="CANCELAR"
    loadingSave={loadingSave}
    closeModal={handleClose}
  >

    {/* SubLabel */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>{subLabel}:</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <input
          type="text"
          value={propietario.subname || ""}
          className="w-full px-2.5 py-1.5 border border-gray-300 rounded"
          disabled
        />
      </div>
    </div>

    {/* Vivienda */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Vivienda:</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <input
          type="text"
          value={Iviv}
          onChange={(e) => setIviv(e.target.value)}
          className="w-full px-2.5 py-1.5 border border-gray-300 rounded"
          disabled
          required
        />
      </div>
    </div>

    {/* Teléfono */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Teléfono:</b><b className="text-red-500"> *</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <PhoneInput
          defaultCountry="MX"
          value={ITelefono}
          onChange={(value) => setITelefono(value)}
          error={telefonoError}
          disabled
          readOnly
          className="w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
        />
      </div>
    </div>

    {/* Nombre */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Nombre completo:</b><b className="text-red-500"> *</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <input
          type="text"
          value={INombre}
          onChange={(e) => setINombre(e.target.value)}
          className="w-full px-2.5 py-1.5 border border-gray-300 rounded"
          disabled
          required
        />
      </div>
    </div>

    {/* Género y correo */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Género:</b></p>
      </div>
      <div className="flex-1 flex items-center px-2 py-1">
        <select
          value={IGenero}
          onChange={(e) => setIGenero(e.target.value)}
          className="bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded"
          required
        >
          <option value="0">Hombre</option>
          <option value="1">Mujer</option>
          <option value="2">No especificado</option>
        </select>
      </div>
      {/* Correo */}
      <div className="basis-1/4 flex justify-center items-center font-bold mb-1 md:mb-0">
        <p><b>Correo:</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-2.5 py-1.5 border border-gray-300 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>

    {/* Identificación */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Identificación:</b></p>
      </div>
      <div className="flex-1 flex items-center px-2 py-1">
        <select
          value={IId}
          onChange={(e) => setIId(e.target.value)}
          className=" bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded"
        >
          <option value="0">INE</option>
          <option value="1">Pasaporte/Visa</option>
          <option value="2">Curp</option>
          <option value="3">Cartilla Militar</option>
        </select>
      </div>
      <div className="basis-1/4 flex justify-center items-center font-bold mb-1 md:mb-0">
        <p><b>ID:</b></p>
      </div>
      <div className="flex-1 flex items-center px-2 py-1">
        <input
          type="text"
          value={INumId}
          onChange={(e) => setINumId(e.target.value)}
          className="bg-gray-100   w-full px-2.5 py-1.5 border border-gray-300 rounded"
        />
      </div>
    </div>

    {/* Dirección */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
        <p><b>Dirección:</b></p>
      </div>
      <div className="flex-1 px-2 py-1">
        <input
          type="text"
          value={IDireccion}
          onChange={(e) => setIDireccion(e.target.value)}
          className="bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded"
        />
      </div>
    </div>

   {/* Municipio y Ciudad */}
<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
  <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
    <p><b>Municipio:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="text"
      value={IMunicipio}
      onChange={(e) => setIMunicipio(e.target.value)}
      className="w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
    />
  </div>
  <div className="basis-1/4 flex justify-center items-center font-bold mb-1 md:mb-0">
    <p><b>Ciudad:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="text"
      value={citye}
      onChange={(e) => setCitye(e.target.value)}
      className="w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
    />
  </div>
</div>

{/* CP y Estado */}
<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
  <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
    <p><b>C.P:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="text"
      value={ICp}
      onChange={(e) => setICp(e.target.value)}
      className="bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
  <div className="basis-1/4 flex  justify-center items-center font-bold mb-1 md:mb-0">
    <p><b>Estado:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="text"
      value={IEstado}
      onChange={(e) => setIEstado(e.target.value)}
      className="bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
</div>

{/* País */}
<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
  <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
    <p><b>País:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="text"
      value={IPais}
      onChange={(e) => setIPais(e.target.value)}
      className=" bg-gray-100 w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
</div>
{/* Fechas */}
<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
  <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
    <p>
      <b>Fecha de compra:</b>
      <b className="text-red-500"> *</b>
    </p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="date"
      value={pFechaCompra}
      onChange={(e) => setPFechaCompra(e.target.value)}
      className="bg-gray-100   w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      required
    />
  </div>
  <div className="basis-1/4 flex justify-center items-center font-bold mb-1 md:mb-0">
    <p><b>Fecha de venta:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <input
      type="date"
      value={pFechaVenta}
      onChange={(e) => setPFechaVenta(e.target.value)}
      className="bg-gray-100    w-full px-2.5 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
</div>
    {/* Comentarios  */}
<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
  <div className="basis-1/4 flex items-center font-bold mb-1 md:mb-0">
    <p><b>Comentarios:</b></p>
  </div>
  <div className="flex-1 px-2 py-1">
    <textarea
      value={comentarios}
      onChange={(e) => setComentarios(e.target.value)}
      rows="3"
      maxLength="500"
      className="bg-gray-100  w-full px-2.5 py-1.5 border border-gray-300 rounded resize-y focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
</div>


    {/* Estado residente */}
    <div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
      <div className="flex-1 px-2 py-1">
        {esResidente ? (
          <span className="text-green-600 font-bold flex items-center gap-1">
            <b>Es residente</b> <i className="fas fa-check"></i>
          </span>
        ) : (
          <span className="text-red-600 font-bold"><b>No es residente</b></span>
        )}
      </div>
    </div>

    {/* Nota */}
    <div className="mt-3 text-sm text-gray-600">
      <small><b className="text-red-500"> * </b> Indica un campo obligatorio</small>
    </div>

  </DinamicModal>
);


}

export default PropietarioEditarModal;

